import React from "react";
import FaqSection from "components/FaqSection";
import GuideSection from "components/GuideSection";
import Link from "next/link";
import SideBar from "./SideBar";
import {
  HeaderH2,
  HeaderH1,
  Text,
  NextButton,
  ImageBlock,
} from "components/TextBlocks";
import {
  AddNote,
  FullScreen,
  MoveIcon,
  OpenIcon,
  TrashIcon,
  AddIcon,
  CompactViewIcon,
  SortIcon,
} from "components/IconBlocks";

function GroupOptions(props) {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return (
    <>
      <HeaderH1>Group options</HeaderH1>
      <Text>
        To access the options hover the group and tap the icon in the right-hand
        corner.
      </Text>
      {/* <ImageBlock
        src={"/guide/SpaceOptionsButton.png"}
        width={504}
        height={292}
        quality={99}
        alt={"Change username"}
      /> */}
      <Text>The options includes:</Text>
      <div style={{ display: "flex" }}>
        <div
          style={{
            marginBottom: "auto",
            marginTop: "3px",
            marginRight: "12px",
          }}
        >
          <OpenIcon />
        </div>
        <Text>
          Open in new window, opens all the groups sites in a new
          window(perserving the last saved position of the window, if save was
          done via a mass save option).
        </Text>
      </div>
      <div style={{ display: "flex" }}>
        <div
          style={{
            marginBottom: "auto",
            marginTop: "3px",
            marginRight: "12px",
          }}
        >
          <AddIcon />
        </div>
        <Text>
          Add custom url - Opens a modal where you can enter a title and a url
          of your choice. This creates a new item and adds it to the current
          group.{" "}
        </Text>
      </div>
      <div style={{ display: "flex", marginTop: "24px" }}>
        <div
          style={{
            marginBottom: "auto",
            marginTop: "3px",
            marginRight: "12px",
          }}
        >
          <FullScreen />
        </div>
        <Text>
          Copy content - Copy all content in the group to your clipboard
          including urls, comments and to-dos.
        </Text>
      </div>
      <div style={{ display: "flex", marginTop: "24px" }}>
        <div
          style={{
            marginBottom: "auto",
            marginTop: "3px",
            marginRight: "12px",
          }}
        >
          <MoveIcon />
        </div>
        <Text>
          Move to - Move selected group into another category of your choice.
        </Text>
      </div>
      <div style={{ display: "flex", marginTop: "24px" }}>
        <div
          style={{
            marginBottom: "auto",
            marginTop: "3px",
            marginRight: "12px",
          }}
        >
          <SortIcon />
        </div>
        <Text>
          Sort by - Sort the items in the group, alphabetically or by date
          saved.
        </Text>
      </div>
      <div style={{ display: "flex", marginTop: "24px" }}>
        <div
          style={{
            marginBottom: "auto",
            marginTop: "3px",
            marginRight: "12px",
          }}
        >
          <CompactViewIcon />
        </div>
        <Text>
          Compact view - If enabled, the items inside the group will take less
          space vertically.
        </Text>
      </div>
      <div style={{ display: "flex", marginTop: "24px" }}>
        <div
          style={{
            marginBottom: "auto",
            marginTop: "3px",
            marginRight: "12px",
          }}
        >
          <TrashIcon />
        </div>
        <Text>Delete - Deletes the group and all containing items.</Text>
      </div>
      <NextButton
        cta={"Categories"}
        textColor={"#565D65"}
        bg={"#EBECED"}
        page={"/guide/categories"}
      />
    </>
  );
}

GroupOptions.Layout = SideBar;

export default GroupOptions;
